export default __webpack_public_path__ + "static/media/Yaskawa.54234f7d.JPG";